import React from "react";
import "./style.scss";

export const DisabledOverlay = ({ show }) =>
  show ? (
    <div className="disabled-overlay" onClick={(e) => e.stopPropagation()} />
  ) : (
    ""
  );
